import { Component, computed, HostBinding, HostListener, inject } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';
import { CollectionFilterDirective } from './collection-filter.directive';

@Component({
  selector: 'ciphr-collection-filter-header',
  standalone: true,
  imports: [ChrComponentsModule],
  templateUrl: './collection-filter-header.component.html',
  styleUrl: './collection-filter-header.component.scss',
})
export class CollectionFilterHeaderComponent {
  private readonly collectionFilterDirective = inject(CollectionFilterDirective);
  private readonly translocoService = inject(TranslocoService);

  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabindex = 0;

  @HostBinding('attr.aria-expanded') get ariaExpanded() {
    return this.expanded();
  }

  @HostBinding('attr.aria-label') get ariaLabel() {
    return this.translocoService.translate('COMMON.COLLECTIONS.ARIA.BUTTONS.FILTER_HEADER', { filterKey: this.filter().label });
  }

  @HostListener('click')
  @HostListener('keydown.enter')
  toggleExpansion(): void {
    this.collectionFilterDirective.toggleExpansion();
  }

  chevronIcon = computed(() => (this.expanded() ? 'chevron-down' : 'chevron-right'));
  expanded = this.collectionFilterDirective.expanded;
  filter = this.collectionFilterDirective.filter;
  selectedValues = this.collectionFilterDirective.selectedValues;
}
